// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component, Prop } from "vue-property-decorator";

//Components
import WithRender from "Components/Search/ProductSearchCard/product-search-card.html";


@WithRender
@Component()

export default class ProductSearchCard extends Vue {
  @Prop({}) displayName: string;
  @Prop({}) additionalDisplayName: string;
  @Prop({}) stockNumber: string;
  @Prop({}) primaryImageUrl: string;
  @Prop({}) url: string;
  @Prop({}) highlightResults: any;
}
